export const setPayoutDetails = {
  SET_PAYOUT_DETAILS(state, payload) {
    state.payoutDetails = payload;
  }
};
